module.exports = __webpack_public_path__ + "img/logo_en.4ceb1136.svg";